/**
 * LYBERHOT Security Module
 * Proteção contra screenshots, capturas e ataques
 */

class SecurityProtection {
  constructor() {
    this.isDevToolsOpen = false;
    this.init();
  }

  init() {
    this.disableRightClick();
    this.disablePrintScreen();
    this.disableDevTools();
    this.blurOnWindowBlur();
    this.disableTextSelection();
    this.detectScreenCapture();
  }

  /**
   * Desabilitar botão direito em conteúdo premium
   */
  disableRightClick() {
    document.addEventListener('contextmenu', (e) => {
      // Verificar se está em conteúdo premium
      if (e.target.closest('.premium-content, .story-content, .protected-image')) {
        e.preventDefault();
        console.log('🛡️ Conteúdo protegido');
        return false;
      }
    });
  }

  /**
   * Desabilitar Print Screen (parcial - não funciona em todos navegadores)
   */
  disablePrintScreen() {
    document.addEventListener('keyup', (e) => {
      // Print Screen
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText('');
        alert('🚫 Screenshots não são permitidos neste conteúdo');
      }
    });

    // Detectar combinações de teclas
    document.addEventListener('keydown', (e) => {
      // Cmd+Shift+3/4 (Mac screenshot)
      if (e.metaKey && e.shiftKey && (e.key === '3' || e.key === '4')) {
        e.preventDefault();
        alert('🚫 Screenshots não são permitidos');
        return false;
      }

      // Windows+Shift+S (Windows Snipping Tool)
      if (e.key === 's' && e.shiftKey && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        alert('🚫 Screenshots não são permitidos');
        return false;
      }
    });
  }

  /**
   * Detectar e alertar sobre DevTools
   */
  disableDevTools() {
    // Detectar DevTools aberto
    const detectDevTools = () => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160;
      const heightThreshold = window.outerHeight - window.innerHeight > 160;
      
      if (widthThreshold || heightThreshold) {
        if (!this.isDevToolsOpen) {
          this.isDevToolsOpen = true;
          console.clear();
          console.log('%c🛡️ LYBERHOT Security', 'font-size: 24px; color: red; font-weight: bold;');
          console.log('%cAtenção: Não use ferramentas de desenvolvedor neste site!', 'font-size: 16px; color: orange;');
        }
      } else {
        this.isDevToolsOpen = false;
      }
    };

    setInterval(detectDevTools, 1000);

    // Desabilitar F12
    document.addEventListener('keydown', (e) => {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
        return false;
      }
    });
  }

  /**
   * Blur conteúdo quando janela perde foco
   */
  blurOnWindowBlur() {
    let blurTimeout;

    window.addEventListener('blur', () => {
      // Aplicar blur após 500ms (evitar falsos positivos)
      blurTimeout = setTimeout(() => {
        document.querySelectorAll('.premium-content, .story-content').forEach(el => {
          el.style.filter = 'blur(20px)';
          el.style.transition = 'filter 0.3s';
        });
      }, 500);
    });

    window.addEventListener('focus', () => {
      clearTimeout(blurTimeout);
      document.querySelectorAll('.premium-content, .story-content').forEach(el => {
        el.style.filter = 'none';
      });
    });
  }

  /**
   * Desabilitar seleção de texto em conteúdo premium
   */
  disableTextSelection() {
    const style = document.createElement('style');
    style.textContent = `
      .premium-content,
      .protected-image,
      .story-content {
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-touch-callout: none;
      }

      .premium-content img,
      .protected-image img,
      .story-content img,
      .story-content video {
        pointer-events: none;
        -webkit-user-drag: none;
        user-drag: none;
      }

      @media print {
        .premium-content,
        .story-content {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Detectar possíveis tentativas de captura de tela
   */
  detectScreenCapture() {
    // Detectar quando a página perde visibilidade
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        console.log('🔍 Página oculta - possível captura');
        // Aqui você pode registrar um log no backend
      }
    });

    // Detectar extensões de captura de tela (parcial)
    if (window.chrome && window.chrome.runtime) {
      console.log('⚠️ Extensões do Chrome detectadas');
    }
  }

  /**
   * Adicionar watermark dinâmico
   */
  addWatermark(username, element) {
    if (!element) return;

    const watermark = document.createElement('div');
    watermark.className = 'dynamic-watermark';
    watermark.textContent = `@${username} • ${new Date().toLocaleString('pt-BR')}`;
    
    // Estilo do watermark
    watermark.style.cssText = `
      position: absolute;
      top: ${Math.random() * 80 + 10}%;
      left: ${Math.random() * 80 + 10}%;
      color: rgba(255, 255, 255, 0.3);
      font-size: 12px;
      pointer-events: none;
      z-index: 9999;
      text-shadow: 0 0 2px rgba(0,0,0,0.5);
      transform: rotate(-30deg);
      user-select: none;
    `;

    element.style.position = 'relative';
    element.appendChild(watermark);

    // Adicionar múltiplos watermarks
    for (let i = 0; i < 3; i++) {
      setTimeout(() => {
        const clone = watermark.cloneNode(true);
        clone.style.top = `${Math.random() * 80 + 10}%`;
        clone.style.left = `${Math.random() * 80 + 10}%`;
        element.appendChild(clone);
      }, i * 100);
    }
  }

  /**
   * Proteção para vídeos
   */
  protectVideo(videoElement) {
    if (!videoElement) return;

    // Desabilitar picture-in-picture
    videoElement.disablePictureInPicture = true;
    
    // Desabilitar download
    videoElement.controlsList = 'nodownload noplaybackrate';
    
    // Desabilitar right-click
    videoElement.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });
  }

  /**
   * Proteção para imagens
   */
  protectImage(imgElement) {
    if (!imgElement) return;

    // Desabilitar arrastar
    imgElement.draggable = false;
    
    // Desabilitar right-click
    imgElement.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });

    // Adicionar overlay invisível
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      cursor: pointer;
    `;
    
    if (imgElement.parentElement) {
      imgElement.parentElement.style.position = 'relative';
      imgElement.parentElement.appendChild(overlay);
    }
  }
}

// Inicializar proteções automaticamente
if (typeof window !== 'undefined') {
  window.SecurityProtection = SecurityProtection;
  window.security = new SecurityProtection();
  
  console.log('🛡️ LYBERHOT Security Protection: Ativado');
}

export default SecurityProtection;
